import React from 'react';

/**
 * 4-stat card row for the landing page.
 */
export default function StatsBanner({ stats }) {
  const items = [
    { label: 'Cards Studied', value: stats.totalCardsStudied || 0, icon: '🗂️' },
    { label: 'Exams Done', value: stats.examsCompleted || 0, icon: '🎯' },
    { label: 'Drill Accuracy', value: `${Math.round((stats.drillAccuracy || 0) * 100)}%`, icon: '⌨️' },
    { label: 'Readiness', value: `${stats.overallReadiness || 0}%`, icon: '📊',
      color: stats.overallReadiness >= 70 ? '#2ECC71' : stats.overallReadiness >= 40 ? '#F39C12' : '#E74C3C' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-4xl mx-auto mb-8">
      {items.map(item => (
        <div key={item.label} className="bg-gray-800/50 border border-gray-700/50 rounded-lg p-4 text-center">
          <div className="text-2xl mb-1">{item.icon}</div>
          <div className="text-xl font-bold text-white" style={item.color ? { color: item.color } : undefined}>
            {item.value}
          </div>
          <div className="text-xs text-gray-400 mt-1">{item.label}</div>
        </div>
      ))}
    </div>
  );
}
